import type { TimeAttendanceStepProps } from "@/types/timeAttendance";
import { BadgeCheck } from "lucide-react";

const TimeAttendanceRuleFinalStep: React.FC<TimeAttendanceStepProps> = ({
  successMessage,
}) => {
  return (
    <div className="py-4 flex flex-col items-center justify-center">
      {/* Success Icon */}
      <div className="mb-2 relative">
        {/* Badge shape with checkmark */}
        <div className="relative flex items-center justify-center">
          <BadgeCheck className="w-14 h-14 text-green-500" strokeWidth={1} />
        </div>
      </div>
      <h3 className="text-lg max-w-[300px] font-semibold text-green-600 mb-2 text-center">
        {successMessage}
      </h3>
    </div>
  );
};

export default TimeAttendanceRuleFinalStep;
